export const timeout = (durationMS: number) =>
  new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, durationMS);
  });
